import React from "react";
import keyBy from "lodash/keyBy";
import { useUserFilters } from "Hooks/useUserFilters";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { FilterChip } from "./FilterChip/FilterChip";
import { getLocationsFilterCache } from "Shared/utils/LocationsFilterCache";

const FilterChips = () => {
  const { userFilters, removeFilter } = useUserFilters();
  const { companies } = usePartnerConfig();
  const companiesMap = keyBy(companies, "id");

  const cachedLocations = getLocationsFilterCache();
  const locationsMap = keyBy(cachedLocations, "id");

  return (
    <>
      {
        userFilters.employmentStatuses.map((employmentStatus) => (
          <FilterChip
            label="Employment Status"
            value={employmentStatus}
            key={`EmploymentStatus-${employmentStatus}`}
            onDelete={() => removeFilter("employmentStatuses", employmentStatus)}
          />
        ))
      }
      {
        userFilters.userStatuses.map((userStatus) => (
          <FilterChip
            label="DailyPay Status"
            value={userStatus}
            key={`DailyPayStatus-${userStatus}`}
            onDelete={() => removeFilter("userStatuses", userStatus)}
          />
        ))
      }
      {
        userFilters.payGroupIds.map((payGroupId) => (
          <FilterChip
            key={`PayGroup-${payGroupId}`}
            label="Pay Group"
            value={companiesMap[payGroupId]?.payGroup}
            onDelete={() => removeFilter("payGroupIds", payGroupId)}
          />
        ))
      }
      {
        userFilters.locationIds.map((locationId) => (
          <FilterChip
            key={`Location-${locationId}`}
            label="Location"
            value={locationsMap[locationId]?.name || ""}
            onDelete={() => removeFilter("locationIds", locationId)}
          />
        ))
      }
      {
        userFilters.benefitTypes.map((benefitType) => (
          <FilterChip
            key={`Benefit-${benefitType}`}
            label="Benefit Type"
            value={benefitType}
            onDelete={() => removeFilter("benefitTypes", benefitType)}
          />
        ))
      }
    </>
  );
};

export default FilterChips;
